<template>
    <div class="detail" v-if="detail.informationContent">
        <!-- <navbar title="动态详情" /> -->
        <div class="content ql-snow">
            <div class="title">{{detail.informationSubject}}</div>
            <div class="desc">
                <div class="des">{{detail.informationPublisherName}}</div>
                <div class="time">{{detail.publishDate}}</div>
            </div>
            <div class="rawHtml ql-editor" v-html="detail.informationContent"></div>
        </div>
        <div class="praise">
            <div class="read">阅读：{{detail.readVolume}}</div>
            <div :class="[detail.likeStatus ? 'haveparise' : 'noparise', 'pariseImg']" @click="toPrise(detail.likeStatus)">
                <img :src="detail.likeStatus ? require('../../assets/zan2.png') : require('../../assets/zan.png')" alt="">
                <span>赞 {{detail.likeVolume}}</span>
            </div>
        </div>
    </div>
</template>

<script>
import navbar from '@/components/navbar/index';
import { clientGetInformationById, clientLikeInformation, clientCancelLikeInformation } from '@/api/officialDynamic';
export default {
    name: 'articleDetail',
    components: {
        navbar
    },
    data() {
        return {
            detail: {
                informationSubject: '',
                informationPublisherName: '',
                publishDate: '',
                informationContent:'',
                readVolume: '',
                likeStatus: true,
                likeVolume: ''
            },
            informationId: '',
            userId: ''
        }
    },
    created() {
        console.log(this.$route)
        this.userId = this.$route.path.split('&id=')[1];
        if(this.$route.params.id) {
            this.informationId = this.$route.params.id.split('&id=')[0]
        }
        this.clientGetInformationById()
    },
    methods: {
        // 获取详情(
        clientGetInformationById() {
            clientGetInformationById({informationId: this.informationId, userId: this.userId})
                .then(res => {
                    if(res.status === 200 && res.content) {
                        this.detail = res.content
                    }
                })
        },
        toPrise(status) {
            if(status) {
                this.clientCancelLikeInformation()
            }
            else {
                this.clientLikeInformation()
            }
        },
        //点赞
        clientLikeInformation() {
            clientLikeInformation({informationId: this.informationId,userId: this.userId})
                .then(res => {
                    if(res.status === 200) {
                        this.detail.likeStatus = true;
                        this.detail.likeVolume ++;
                    }
                })  
        },
        // 取消点赞
        clientCancelLikeInformation() {
            clientCancelLikeInformation({informationId: this.informationId,userId: this.userId})
                .then(res => {
                    if(res.status === 200) {
                        this.detail.likeStatus = false;
                        if(+this.detail.likeVolume !== 0) {
                            this.detail.likeVolume --;
                        }
                    }
                })
        }
    }
}
</script>

<style lang="scss" scoped>
.detail {
    display: flex;
    flex-direction: column;
    height: 100vh;
    .leftarrow {
        width: .24rem;
        height: .4rem;
    }
    .blackdot {
        width: .46rem;
        height: .1rem;
    }
    .content {
        padding: .36rem 0;
        flex: 1;
        .title {
            font-size: .4rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #222222;
            margin-bottom: .22rem;
            padding: 0 .36rem;
        }
        .desc {
            display: flex;
            padding: 0 .36rem;
            font-size: .26rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            .des {
                margin-right: .4rem;
            }
        }
    }
    .praise {
        padding: .36rem .4rem;
        display: flex;
        justify-content: space-between;
        .read {
            font-size: .3rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
        }
        img {
            width: .34rem;
            height: .34rem;
            margin-right: .1rem;
        }
        .pariseImg {
            font-size: .3rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            display: flex;
            align-items: center;
        }
        .haveparise {
            color: #FF7600;
        }
        .noparise {
            color: #666666;
        }
    }
}
</style>